import React from 'react';
import { Box } from '@osmosis/react-ui/components/Box';
import { BoxProps } from '@osmosis/react-ui/components/Box';

/**
 * Wrapper for a block.
 */
const BlockWrapper = (props: BoxProps) => (
  <Box maxWidth={1160} m="auto" px={4} py={5} {...props} />
);

export default BlockWrapper;
